/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useServiceUrl } from 'domain/shared/service';

const EditServiceButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useServiceUrl();
  return <EditButton {...props} path={getUpdateEntityUrl} />;
};

export default EditServiceButton;
